export default {
  /*
   * index() lista las variantes
   */
  async index(params) {
    const {data} = await Vue.http.get('topology/variants', {params})
    return data
  }
}
